import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/loadscreenview", { }, successCallback, failureCallback);
    },
    loadCountryList: (successCallback, failureCallback) => {
        ApiService.postWithOffline("/default/getcountrycode", { }, successCallback, failureCallback);
    },
    getRoomList: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/getroomlist", params, successCallback, failureCallback);
    },
    getRoomInfo: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/getroominfo", params, successCallback, failureCallback);
    },
    sendSmsCode: (isoCode, countryCode, phone, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/sendsmscode",
                        {isoCode, countryCode, phone}, successCallback, failureCallback);
    },
    createRoom: (isoCode, countryCode, phone, verifyCode, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/createroom",
                        {isoCode, countryCode, phone, verifyCode}, successCallback, failureCallback);
    },
    getBlackList: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/getblacklist", params, successCallback, failureCallback);
    },
    follow: (roomId, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/follow", {roomId}, successCallback, failureCallback);
    },
    unfollow: (roomId, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/unfollow", {roomId}, successCallback, failureCallback);
    },
    getConsumes: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/getconsumes", params, successCallback, failureCallback);
    },
    getMyInfo: (successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/getmyinfo", { }, successCallback, failureCallback);
    },
    createRoomRewardFeeOrder: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/createRoomRewardFeeOrder", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
